import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import FilterListIcon from '@material-ui/icons/FilterList';

import Paper from '@material-ui/core/Paper';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Popper from '@material-ui/core/Popper';

import DataTableColumnFilterForm from './DataColumnFilterForm/DataTableColumnFilterForm';

const FilterPopper = styled(Popper)`
  z-index: 3;
`;

const DataTableColumnFilter = ({ active, currentFilter, setCurrentFilter, id, onFilterOpen }) => {
  const anchorEl = useRef(null);
  const [filterOpened, setFilterOpened] = useState(false);
  const [loading, setLoading] = useState(false);
  const [filterList, setFilterList] = useState([]);
  const classes = ['icon'];
  if (!active) {
    classes.push('inactive');
  }

  const toggleFilterDialog = () => {
    setFilterOpened(!filterOpened);
  };

  useEffect(() => {
    if (filterOpened) {
      setLoading(true);
      (async () => {
        const data = await onFilterOpen(id);
        setFilterList(data);
        setLoading(false);
      })();
    }
  }, [filterOpened, id, onFilterOpen]);

  return (
    <React.Fragment>
      <FilterListIcon className={classes.join(' ')} ref={anchorEl} onClick={toggleFilterDialog} />
      <FilterPopper open={filterOpened} anchorEl={anchorEl.current}>
        <ClickAwayListener onClickAway={toggleFilterDialog}>
          <Paper>
            <DataTableColumnFilterForm
              onClose={toggleFilterDialog}
              loading={loading}
              data={filterList || []}
              setCurrentFilter={setCurrentFilter}
              currentFilter={currentFilter}
            />
          </Paper>
        </ClickAwayListener>
      </FilterPopper>
    </React.Fragment>
  );
};

DataTableColumnFilter.propTypes = {
  active: PropTypes.bool,
  currentFilter: PropTypes.array,
  setCurrentFilter: PropTypes.func,
  onFilterOpen: PropTypes.func,
  id: PropTypes.string,
};

export default DataTableColumnFilter;
